<div data-testid="charge-category-create-container">
  <form
    *ngIf="serverCategoryForm"
    [formGroup]="serverCategoryForm"
    (ngSubmit)="updateServiceCategory()"
    data-testid="charge-category-form"
  >
    <!-- Header -->
    <div
      class="
        p-3
        flex
        align-items-center
        justify-content-between
        border-bottom-1 border-300
        -mt-3
      "
      data-testid="charge-category-header"
    >
        <h2 class="mb-0 text-sm" data-testid="charge-category-title">
          {{activeCategory?('ADMIN.CHARGE.EDIT_CHARGE_CATEGORY' | translate):('ADMIN.CHARGE.CREATE_CHARGE_CATEGORY' | translate) }}
        </h2>
      <div
        class="fa fa-times text-xl text-600 cursor-pointer"
        (click)="categoryCancel()"
        aria-label="close-charge-category-create-dialog-button"
        data-testid="close-charge-category-create-dialog-button"
      ></div>
    </div>
    <!-- Header -->

    <!-- Content -->
    <div class="surface-100 p-3 text-sm" data-testid="charge-category-content">
      <!-- Service Category Name (English) -->
      <div class="mb-1">
        <label class="text-sm mb-2 block" data-testid="charge-category-name-primary-label">
          {{ 'ADMIN.CHARGE.CHARGE_CATEGORY_NAME' | translate }}
          <span *ngIf="isSecondaryLanguage">({{ primaryLanguage | translate }}) </span></label
        >
        <input
          formControlName="name_primary_language"
          type="text"
          pInputText
          class="w-full text-sm"
          placeholder=""
          value="Personal Training"
          aria-label="charge-category-name-primary-input"
          data-testid="charge-category-name-primary-input"
        />
      </div>
      <app-error-msg
        *ngIf="NamePrimary?.touched"
        [errors]="NamePrimary?.errors"
        [fieldLabel]="'ADMIN.CHARGE.CHARGE_CATEGORY_NAME' | translate"
        data-testid="charge-category-name-primary-error"
      >
      </app-error-msg>
      <!-- Service Category Name (English) -->

      <!-- Service Category Name (French) -->
      <div class="mb-1" *ngIf="isSecondaryLanguage">
        <label class="text-sm mb-2 block" data-testid="charge-category-name-secondary-label">
          {{ 'ADMIN.CHARGE.CHARGE_CATEGORY_NAME' | translate }} ({{
            secondaryLanguage | translate
          }})</label
        >
        <input
          formControlName="name_secondary_language"
          type="text"
          pInputText
          class="w-full text-sm"
          placeholder=""
          value="Personal Training"
          aria-label="charge-category-name-secondary-input"
          data-testid="charge-category-name-secondary-input"
        />
      </div>

      <app-error-msg
        *ngIf="NameSecondary?.touched"
        [errors]="NameSecondary?.errors"
        [fieldLabel]="'ADMIN.CHARGE.CHARGE_CATEGORY_NAME' | translate"
        data-testid="charge-category-name-secondary-error"
      >
      </app-error-msg>
      <!-- Service Category Name (French) -->

      <!-- Service Category Description (English) -->
      <div class="mb-1">
        <label class="text-sm mb-2 block" data-testid="charge-category-description-primary-label">
          {{ 'ADMIN.CHARGE.CHARGE_CATEGORY_DESCRIPTION' | translate }} <span *ngIf="isSecondaryLanguage">({{
            primaryLanguage | translate
          }})
          </span> </label
        >
        <textarea
          pInputTextarea
          formControlName="description_primary_language"
          class="w-full text-sm"
          aria-label="charge-category-description-primary-input"
          data-testid="charge-category-description-primary-input"
        >
        {{
            'ADMIN.CHARGE.CHARGE_CATEGORY_DESCRIPTION'
              | translate
          }}
</textarea
        >
      </div>
      <app-error-msg
        *ngIf="DescriptionPrimary?.touched"
        [errors]="DescriptionPrimary?.errors"
        [fieldLabel]="'ADMIN.CHARGE.CHARGE_CATEGORY_DESCRIPTION' | translate"
        data-testid="charge-category-description-primary-error"
      >
      </app-error-msg>
      <!-- Service Category Description (English) -->

      <!-- Service Category Description (French) -->
      <div class="mb-1"  *ngIf="isSecondaryLanguage">
        <label class="text-sm mb-2 block" data-testid="charge-category-description-secondary-label">
          {{ 'ADMIN.CHARGE.CHARGE_CATEGORY_DESCRIPTION' | translate }} ({{
            secondaryLanguage | translate
          }})</label
        >
        <textarea
          pInputTextarea
          formControlName="description_secondary_language"
          class="w-full text-sm"
          aria-label="charge-category-description-secondary-input"
          data-testid="charge-category-description-secondary-input"
        >
        {{
            'ADMIN.CHARGE.CHARGE_CATEGORY_DESCRIPTION'
              | translate
          }}</textarea
        >
      </div>
      <app-error-msg
        *ngIf="DescriptionSecondary?.touched"
        [errors]="DescriptionSecondary?.errors"
        [fieldLabel]="'ADMIN.CHARGE.CHARGE_CATEGORY_DESCRIPTION' | translate"
        data-testid="charge-category-description-secondary-error"
      >
      </app-error-msg>
      <!-- Service Category Description (French) -->
    </div>
    <!-- Content -->

    <!-- Footer -->
    <div
      class="
        p-3
        flex
        justify-content-between
        align-items-center
        border-top-1 border-300
        -mb-3
      "
      data-testid="form-actions"
    >
      <button
        pButton
        pRipple
        type="button"
        label="{{ 'ADMIN.COMMON.CANCEL' | translate }}"
        styleClass="text-sm"
        class="p-button-text text-sm"
        (click)="categoryCancel()"
        aria-label="cancel-charge-category-button"
        data-testid="cancel-charge-category-button"
      ></button>
      <button
        pButton
        pRipple
        type="submit"
        label="{{ 'ADMIN.COMMON.SAVE' | translate }}"
        class="text-sm"
        aria-label="save-charge-category-button"
        data-testid="save-charge-category-button"
      ></button>
    </div>
    <!-- Footer -->
  </form>
</div>

